module.exports = __webpack_public_path__ + "img/pitching7.d6ef3104.png";